import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Classificazione} from "../../../../../../../common/models/classificazione";
import {Observable} from "rxjs";
import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from "@angular/core";
import {Oggetto} from "../../../../../../../common/models/tipologiche/oggetto";
import {HelpersService} from "../../../../../../../core/services/helpers.service";
import {Argomento} from "../../../../../../../common/models/tipologiche/argomento";
import {Materia} from "../../../../../../../common/models/tipologiche/materia";
import { CreazionePraticaTipologicheService } from "../../../../services/creazione-pratica-tipologiche.service";
import { SimpleChanges } from "@angular/core";


@Component({
  selector: 'app-classificazione-form',
  templateUrl: './classificazione-form.component.html',
  styleUrls: ['./classificazione-form.component.css']
})
export class ClassificazioneFormComponent implements OnInit, OnChanges {

  @Input() hasPrincipale: boolean;
  @Output() classificazioniChange: EventEmitter<Classificazione> = new EventEmitter<Classificazione>()
  materieOptions$: Observable<Materia[]>;
  oggettiOptions$: Observable<Oggetto[]>;
  argomentiOptions$: Observable<Argomento[]>;

  formGroup: FormGroup;
  constructor(private tipologicheService: CreazionePraticaTipologicheService, private formBuilder: FormBuilder) {

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasPrincipale && this.formGroup) {
      this.formGroup.get('isPrincipale').setValue(!this.hasPrincipale);
    }
  }


  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      materia: [null, Validators.required],
      oggetto: [null, Validators.required],
      argomento: [null],
      isPrincipale: [!this.hasPrincipale],
    })

    this.formGroup.get('materia').valueChanges.subscribe(value => {
      if(value && value.id){
        this.oggettiOptions$ = this.tipologicheService.getOggetti(value.id);
      }
    })

    this.formGroup.get('oggetto').valueChanges.subscribe(value => {
      if(this.formGroup.get('materia').value){
        const idMateria = this.formGroup.get('materia').value.id;
        this.argomentiOptions$ = this.tipologicheService.getArgomenti(idMateria, value.id);
      }
    })

    this.materieOptions$ = this.tipologicheService.getMateria();
  }

  addClassificazione(){
    this.classificazioniChange.emit(this.formGroup.getRawValue());
    this.formGroup.reset();
    this.oggettiOptions$ = null;
    this.argomentiOptions$ = null;
    this.formGroup.get('isPrincipale').setValue(false);
  }

}
